export const getQueryParam = (param) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
};

export const goBackCheckIn = (page) => {
    return page === "CO_EX" ? "/co-ex-company-list" : "/company-list";
};

export const setSelectedCategory = (category) => {
    return category && category !== null ? localStorage.setItem("selectedCategory",JSON.stringify(category)) : localStorage.removeItem("selectedCategory");
};

export const setSearchedText = (text, context = "exhibitor") => {
  const key = `searchedText_${context}`;
  return text && text.trim() !== ""
    ? localStorage.setItem(key, text)
    : localStorage.removeItem(key);
};

export const getSearchedText = (context = "exhibitor") => {
  const key = `searchedText_${context}`;
  return localStorage.getItem(key) || "";
};

export const normalizePhoneNumber = (
  rawValue,
  defaultCountryCode = "+91"
) => {
  if (!rawValue) return '';

  let digits = rawValue.replace(/\D/g, '');

  if (digits.length > 10) {
    return digits;
  }

  return `${defaultCountryCode}${digits}`;
};

export const clearNonAuthLocalStorage = () => {
  // Only remove temporary keys.
  // DO NOT use localStorage.clear() because it triggers 'storage' events
  // with event.key === null, which forces a logout reload in other tabs via useAuthSync.js
  const transientKeys = [
    "orderId",
    "selectedCategory",
    "searchedText_exhibitor",
    "searchedText_visitor"
  ];

  transientKeys.forEach(key => localStorage.removeItem(key));
};

export const getLinksBaseUrl = () => {
  if (typeof window === "undefined") return "";

  const host = window.location.hostname.toLowerCase();
  const isComDomain = host === "fairfest.com" || host.endsWith(".fairfest.com") || host.endsWith(".com");

  return isComDomain ? "https://www.fairfest.com" : "https://fairfest.in";
};

/** Tickets registration origin — prod (.com) vs stage (.in / localhost). */
export const getTicketsBaseUrl = () => {
  if (typeof window === "undefined") return "https://tickets.fairfest.com";

  const host = window.location.hostname.toLowerCase();
  const isComDomain = host === "fairfest.com" || host.endsWith(".fairfest.com") || host.endsWith(".com");

  return isComDomain ? "https://tickets.fairfest.com" : "https://staging-tickets.fairfest.in";
};

export const getUtmData = () => {
  const utmSource = getQueryParam('utm_source') || localStorage.getItem('utm_source');
  if (utmSource && utmSource !== "null") {
    return { utm_source: utmSource };
  }
  return undefined;
};

/** Complimentary exhibitor links omit `?content=`; map to extraData.sections_<content>. */
export const contentFromExhibitorId = (exhId) => {
  if (exhId === '12970') return 'v1_ensemble';
  if (exhId === '13209') return 'v1_wth';
  return undefined;
};

export const getContentData = () => {
  const content =
    getQueryParam('content')
    || contentFromExhibitorId(getQueryParam('exh_id'))
    || localStorage.getItem('content');
  if (content && content !== "null") {
    return content.trim().toLowerCase();
  }
  return undefined;
};

export const isLargeLogoEvent = (eventData) => {
  const id = Number(eventData?.id || eventData?.event_id);
  return id === 30 || id === 24;
};